<div class="people-picker">
  <h1 class="strong" mat-dialog-title>{{ 'shared.picker.scd.headline' | translate }}</h1>
  <div mat-dialog-content>
    <div class="scd-search">
      <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
        <mat-label>{{ 'shared.picker.scd.search.name' | translate }}</mat-label>
        <input
          [ngModel]="searchValueFirstName"
          (ngModelChange)="updateSearchValue($event, 'searchValueFirstName')"
          (keyup.enter)="searchUser()"
          matInput
        />
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
        <mat-label>{{ 'shared.picker.scd.search.surname' | translate }}</mat-label>
        <input
          [ngModel]="searchValueSurname"
          (ngModelChange)="updateSearchValue($event, 'searchValueSurname')"
          (keyup.enter)="searchUser()"
          matInput
        />
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
        <mat-label>{{ 'shared.picker.scd.search.mail' | translate }}</mat-label>
        <input
          [ngModel]="searchValueEmail"
          (ngModelChange)="updateSearchValue($event, 'searchValueEmail')"
          (keyup.enter)="searchUser()"
          matInput
        />
      </mat-form-field>
      <button class="btn btn-secondary btn-withIcon large" (click)="searchUser()">
        <span class="icon icon-Search"></span>
        <span>{{ 'shared.search' | translate }}</span>
      </button>
      <button class="btn btn-secondary btn-withIcon large" (click)="clearSearch()">
        <span class="icon icon-Close-big"></span>
        <span>{{ 'shared.clearFilters' | translate }}</span>
      </button>
    </div>
    <div class="difaTable-container">
      @if (scdPickerIsLoading) {
        <div class="spinner-overlay">
          <mat-spinner></mat-spinner>
        </div>
      }
      <table class="difaTable" [dataSource]="filteredEmployeesToSelect" mat-table matSort>
        <ng-container matColumnDef="check">
          <th *matHeaderCellDef mat-header-cell></th>
          <td *matCellDef="let filteredEmployeesToSelectItem" mat-cell>
            <mat-checkbox
              [checked]="employeeIsSelected(filteredEmployeesToSelectItem)"
              [disableRipple]="true"
              [disabled]="
                !scdPickerData.multipleSelection && didSelectEmployees && !newlySelectedEmployees.includes(filteredEmployeesToSelectItem)
              "
              (change)="addOrRemoveEmployeeToSelection($event.checked, filteredEmployeesToSelectItem)"
            >
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th *matHeaderCellDef mat-header-cell>{{ 'shared.picker.scd.column.name' | translate }}</th>
          <td *matCellDef="let filteredEmployeesToSelectItem" mat-cell>
            <span>{{ filteredEmployeesToSelectItem.firstName }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="surname">
          <th *matHeaderCellDef mat-header-cell>{{ 'shared.picker.scd.column.surname' | translate }}</th>
          <td *matCellDef="let filteredEmployeesToSelectItem" mat-cell>
            <span>{{ filteredEmployeesToSelectItem.surName }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th *matHeaderCellDef mat-header-cell>{{ 'shared.picker.scd.column.mail' | translate }}</th>
          <td *matCellDef="let filteredEmployeesToSelectItem" mat-cell>
            <span>{{ filteredEmployeesToSelectItem.mail }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="department">
          <th *matHeaderCellDef mat-header-cell>{{ 'shared.picker.scd.column.department' | translate }}</th>
          <td *matCellDef="let filteredEmployeesToSelectItem" mat-cell>
            <span>{{ filteredEmployeesToSelectItem.department }}</span>
          </td>
        </ng-container>
        <tr *matRowDef="let row; columns: scdPickerDialogTableSettings.displayedColumns" mat-row></tr>
        <tr *matHeaderRowDef="scdPickerDialogTableSettings.displayedColumns; sticky: true" mat-header-row></tr>
      </table>
    </div>
  </div>
  <div mat-dialog-actions>
    <button class="btn btn-secondary" (click)="close()">
      {{ 'default.close' | translate }}
    </button>
    <button class="btn btn-primary" (click)="apply()">
      {{ 'default.apply' | translate }}
    </button>
  </div>
</div>
